module.exports = __webpack_public_path__ + "img/strip_down.43ac21df.png";